import type { MouseEvent } from 'react'

/**
 * Banda de file grupata a unui ecran de setari - aceeasi ca la User Accounts
 * (`settings/users/UserAccountsPage.tsx`): grupuri cu titlul deasupra si o
 * linie intre ele, `nav.od-tabbar.od-tabbar-grouped`. Regulile de asezare sunt
 * in `public/css/settings_console.css`, sectiunea benzii grupate, deci numele
 * claselor raman exact acelea.
 *
 * Fiecare fila e o legatura adevarata (`href`), ca sa se poata deschide intr-o
 * fila noua; clicul simplu trece prin `onPick`, fara reincarcarea paginii.
 */
export type GroupedTab = { id: string; label: string; icon: string; group: string }

export function GroupedTabBar({
  tabs,
  current,
  hrefOf,
  onPick,
}: {
  tabs: GroupedTab[]
  current: string
  hrefOf(id: string): string
  onPick?(id: string): void
}) {
  /* Grupurile, in ordinea in care apar filele. */
  const groups: { name: string; tabs: GroupedTab[] }[] = []
  for (const item of tabs) {
    const last = groups[groups.length - 1]
    if (last && last.name === item.group) last.tabs.push(item)
    else groups.push({ name: item.group, tabs: [item] })
  }

  const go = (id: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    if (!onPick) return
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    onPick(id)
  }

  return (
    <nav className="od-tabbar od-tabbar-grouped">
      <ul className="od-tabbar-nav">
        {groups.map((group) => (
          <li className="od-tabgroup" key={group.name}>
            <span className="od-tabgroup-title">{group.name}</span>
            <ul className="od-tabgroup-tabs">
              {group.tabs.map((tab) => (
                <li key={tab.id} className={tab.id === current ? 'menu-tab active' : 'menu-tab'}>
                  <a
                    id={tab.id}
                    href={hrefOf(tab.id)}
                    aria-current={tab.id === current ? 'page' : undefined}
                    onClick={go(tab.id)}
                  >
                    <i className={tab.icon} aria-hidden="true"></i> {tab.label}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  )
}
